module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fX30G"))).then(() => parcelRequire('f4eak'));